import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, first, firstValueFrom } from 'rxjs';
import { BusinessUserService } from 'src/app/services/business-user.service';
import { AlertService } from 'src/app/services/common/alert.service';
import { UserTypeEnum } from 'src/app/services/common/constant.service';
import { IndexedDBService } from 'src/app/services/common/indexedDb.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { GlobalService } from 'src/app/services/common/global.service';
import { environment } from 'src/environments/environment';
import { RetailStoreService } from 'src/app/services/retail-store.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit, OnDestroy {
  logoPreviewUrl: SafeUrl | null = null;
  private logoPreviewObjectUrl: string | null = null;
  logoOriginalFile?: File;
  logoCompressedFile?: File;
  logoOriginalSize = '';
  logoCompressedSize = '';
  baseurl: string = '';

  previews: SafeUrl[] = [];
  previewsLogo: SafeUrl[] = [];
  previewsCover: SafeUrl[] = [];
  fitMode: 'fit' | 'stretch' = 'fit';

  previewUrl: SafeUrl | null = null;
  private previewObjectUrl: string | null = null;

  countryCode: any;
  countryList: any[] = [];
  countryFilterList: any[] = [];
  stateList: any[] = [];
  stateFilterList: any[] = [];
  cityList: any[] = [];
  cityFilterList: any[] = [];
  featuredList: any;
  qrCodeValue = '';

  selectedFiles?: FileList;
  selectedFileNames: string[] = [];

  selectedLogoFiles?: FileList;
  selectedLogoFileNames: string[] = [];

  userID: any = '';
  currentUserData: any = [];
  userDetail: any = [];
  minCoverKB = 49;
  maxCoverMB = 2;
  minW = 1299;
  minH = 160;
  targetAspect = 8;
  aspectTolerance = 0.08;

  minLogoKB = 49;
  maxLogoMB = 2;

  readonly logoTip =
    `Upload Organization/Company logo to be displayed on for Customer app\n` +
    `• JPG/PNG, ≥ ${this.minLogoKB} KB and ≤ ${this.maxLogoMB} MB`;

  coverError: string | null = null;
  selectedCoverMeta: { name?: string; bytes?: number; w?: number; h?: number; ratio?: number } = {};

  readonly coverTip =
    'Upload Organization/Company Cover File to be displayed on for Customer app';

  readonly coverSpecTip =
    'Cover\n' +
    '• Recommended 3200×400 (8:1)\n' +
    `• JPG/PNG, ≥ ${this.minCoverKB} KB and ≤ ${this.maxCoverMB} MB\n` +
    '• Minimum 1299×160.';

  allSpecsTip = `${this.coverTip}\n\n${this.coverSpecTip}`;

  selectedCoverFiles?: FileList;
  selectedCoverFileNames: string[] = [];

  profilePhoto: any;
  businessQRCode: any;
  businessQRValue: any;
  isOrganizationUser: any = false;

  submittedUserProfileForm1 = false;
  isSubmitting = false;
  userProfileForm1: FormGroup;
  categories: any;
  subcategories: any[] = [];
  private uppy?: any;
// previewUrl: string | null = null;
  originalFile?: File;
  compressedFile?: File;
  uploading = false;

  originalSize = '';
  compressedSize = '';

  initialFormValues: any = null;
  private formSub?: Subscription;
  isLoadingDetails = false;

  get f1() { return this.userProfileForm1.controls; }

  @Output() valueChangeEditProfile = new EventEmitter();

  constructor(
    private alertService: AlertService,
    private formBuilderUserProfile1: FormBuilder,
    private userService: UserService,
    private businessuserService: BusinessUserService,
    private retailStoreService: RetailStoreService,
    private storageService: StorageService,
    private clipboard: Clipboard,
    private globalService: GlobalService,
    private indexedDbService: IndexedDBService,
    private utilityService: UtilityService,
    private sanitizer: DomSanitizer
  ) { }

  async ngOnInit() {
    this.baseurl = environment.shareUrl;
    this.currentUserData = JSON.parse(this.storageService.getValue(StorageKey.currentUser));
    this.userID = this.currentUserData.id;
    this.utilityService.getProductDetails(this.userID).subscribe(result => {
      this.featuredList = result.data;
    });

    if (this.currentUserData.delegateAccess && (this.currentUserData.userType.includes(UserTypeEnum.ORGANIZATION) || this.currentUserData.userType.includes(UserTypeEnum.BASE_ORGANIZATION) || this.currentUserData.userType.includes(UserTypeEnum.ORGANIZATION_CATALOG) || this.currentUserData.userType.includes(UserTypeEnum.ORGANIZATION_LITE))) {
      this.businessuserService.generate_qrcode().subscribe(async (responseQr: any) => {
        if (responseQr.success) {
          this.businessQRCode = responseQr.data.qrCode;
          this.businessQRValue = responseQr.data.qrCodeValue;
          this.qrCodeValue = this.businessQRValue || '';
        }
      });
    } else {
      this.buildForm();
      this.countryFilterList = this.countryList = await this.indexedDbService.getCountires();
      this.getUserDetail();
    }
  }

  private normalizeValue(val: any): string {
    if (val === null || val === undefined) {
      return '';
    }
    return String(val).trim();
  }

  private captureInitialFormValues(): void {
    if (!this.userProfileForm1) return;
    const raw = this.userProfileForm1.getRawValue();
    this.initialFormValues = {
      web_url: this.normalizeValue(raw.web_url),
      slug: this.normalizeValue(raw.slug),
      firstName: this.normalizeValue(raw.firstName),
      lastName: this.normalizeValue(raw.lastName),
      company: this.normalizeValue(raw.company),
      address: this.normalizeValue(raw.address),
      countryId: this.normalizeValue(raw.countryId),
      stateId: this.normalizeValue(raw.stateId),
      cityId: this.normalizeValue(raw.cityId),
      telephone: this.normalizeValue(raw.telephone)
    };
  }

  get isFormChanged(): boolean {
    if (!this.userProfileForm1 || !this.initialFormValues || this.isLoadingDetails) {
      return false;
    }
    const raw = this.userProfileForm1.getRawValue();
    return Object.keys(this.initialFormValues).some(
      key => this.normalizeValue(raw[key]) !== this.initialFormValues[key]
    );
  }

  hasFormChanged(): boolean {
    return this.isFormChanged;
  }

  private isHttpUrl(v: string): boolean {
    return /^https?:\/\//i.test(v);
  }

  public getTargetUrl(): string {
    const raw = (this.qrCodeValue || '').trim();
    if (!raw) return '';

    if (this.isHttpUrl(raw)) {
      const url = new URL(raw);
      url.searchParams.delete('analyticsSource');
      const [path, query = ''] = url.hash.split('?');
      const params = new URLSearchParams(query);
      params.delete('analyticsSource');
      url.hash = path + (params.toString() ? '?' + params.toString() : '');
      return url.toString();
    }

    if (/^www\./i.test(raw) || /^[\w-]+\.[\w.-]+(\/.*)?$/.test(raw)) {
      return `https://${raw}`;
    }
    return '';
  }

  private toFeaturedProductUrl(currentUrl: string, productId: string, tab: string = 'featured'): string {
    try {
      const u = new URL(currentUrl);
      const hash = u.hash.startsWith('#') ? u.hash.slice(1) : u.hash;
      const [hashPath, hashQuery = ''] = hash.split('?');

      const params = new URLSearchParams(hashQuery);
      const orgId = params.get('organizationId') || '';
      if (orgId) params.set('organizationId', orgId);
      params.set('tab', tab);

      const newHash = `#/deal/featured-product-details/${encodeURIComponent(productId)}?${params.toString()}`;
      return `${u.origin}${u.pathname}${u.search}${newHash}`;
    } catch {
      return currentUrl;
    }
  }

  private getCurrentUserId(): string | null {
    try {
      const raw = localStorage.getItem('currentUser');
      if (!raw) return null;
      const u = JSON.parse(raw);
      return u?.id ?? u?._id ?? null;
    } catch { return null; }
  }

  getFeaturedList(): Promise<any[]> {
    return firstValueFrom(this.utilityService.getProductDetails(this.userID))
      .then((result: any) => {
        this.featuredList = result?.data ?? [];
        return this.featuredList;
      })
      .catch(() => {
        this.featuredList = [];
        return this.featuredList;
      });
  }

  private buildFeaturedOrgUrl(baseUrl: string): string {
    try {
      const u = new URL(baseUrl);
      const hash = u.hash.startsWith('#') ? u.hash.slice(1) : u.hash;
      const [, hashQuery = ''] = hash.split('?');

      const params = new URLSearchParams(hashQuery);
      const orgId = params.get('organizationId') || this.getCurrentUserId() || '';

      if (orgId) params.set('organizationId', orgId);
      params.set('tab', 'featured');

      const newHash = `#/deal/organization?${params.toString()}`;
      return `${u.origin}${u.pathname}${u.search}${newHash}`;
    } catch {
      const orgId = this.getCurrentUserId() || '';
      const origin = (this.baseurl || window.location.origin + '/').replace(/\/+$/, '');
      return `${origin}#/deal/organization?tab=featured${orgId ? `&organizationId=${encodeURIComponent(orgId)}` : ''}`;
    }
  }

  async onClickCopyURL() {
    const baseUrl = this.getTargetUrl() || this.baseurl;
    if (!baseUrl) return;

    const list = await this.getFeaturedList();

    if (!Array.isArray(list) || list.length === 0) {
      const url = this.buildFeaturedOrgUrl(baseUrl);
      this.clipboard.copy(url);
      this.alertService.showSuccess('Link copied');
      return;
    }

    const picked = list.find((it: any) => it?.featureToggle === true);
    const pid = picked?._id ?? picked?.id ?? picked?.productId;

    const url = pid
      ? this.toFeaturedProductUrl(baseUrl, pid)
      : this.buildFeaturedOrgUrl(baseUrl);

    this.clipboard.copy(url);
    this.alertService.showSuccess('Link copied');
  }

  private pickFeaturedProductId(): string | null {
    const list = this.featuredList ?? [];
    if (!Array.isArray(list) || list.length === 0) return null;

    const picked = list.find((it: any) => it?.featureToggle === true) || list[list.length - 1];
    if (!picked) return null;

    return picked._id || picked.id || picked.productId || null;
  }

  private buildFinalShareUrl(): string {
    const baseUrl = this.getTargetUrl();
    if (!baseUrl) return '';
    const pid = this.pickFeaturedProductId();
    return pid ? this.toFeaturedProductUrl(baseUrl, pid) : baseUrl;
  }

  onClickDownloadQrCode(ev?: Event) {
    ev?.preventDefault?.();
    ev?.stopPropagation?.();

    const isStore = !this.isOrganizationUser && this.currentUserData?.userType?.includes(UserTypeEnum.RETAILER);
    const finalUrl = isStore ? this.businessQRValue : this.buildFinalShareUrl();
    if (!finalUrl) return;

    const qrApi = `https://quickchart.io/qr?text=${encodeURIComponent(finalUrl)}&margin=2&size=600`;

    fetch(qrApi)
      .then(res => res.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = (this.userID || 'qr') + '.png';
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        try {
          if (/^https?:\/\//i.test(this.businessQRCode)) {
            fetch(this.businessQRCode)
              .then(r => r.blob())
              .then(b => {
                const url = URL.createObjectURL(b);
                const a = document.createElement('a');
                a.href = url;
                a.download = (this.userID || 'qr') + '.png';
                a.click();
                URL.revokeObjectURL(url);
              })
              .catch(() => { });
          } else {
            const blobData = this.globalService.convertBase64ToBlob(this.businessQRCode);
            const blob = new Blob([blobData], { type: 'image/png' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = (this.userID || 'qr') + '.png';
            a.click();
            URL.revokeObjectURL(url);
          }
        } catch { }
      });
  }

  buildForm(): void {
    this.userProfileForm1 = this.formBuilderUserProfile1.group({
      id: [],
      web_url: [''],
      firstName: ['', [
        Validators.required,
        this.noOnlySpaces,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^(?=.{1,50}$)[A-Za-z]+(?: [A-Za-z]+)*$/)
      ]],
      lastName: ['', [
        this.noOnlySpaces,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^(?=.{1,50}$)[A-Za-z]+(?: [A-Za-z]+)*$/)
      ]],
      company: ['', [
        Validators.required,
        this.noOnlySpaces,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9&.,()\-](?:[A-Za-z0-9&.,()\- ]{0,148}[A-Za-z0-9&.,()\-])?$/)
      ]],
      address: ['', [
        Validators.required,
        this.noOnlySpaces,
        Validators.minLength(5),
        Validators.maxLength(250),
        Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9,.\-\/#() \r\n]{5,250}$/)
      ]],
      slug: ['', [Validators.required, Validators.pattern('^[a-z0-9]+$')]],
      countryId: [{ value: '', disabled: true }],
      stateId: ['', [Validators.required]],
      cityId: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      telephone: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(15),
        Validators.pattern(/^[0-9]{8,15}$/)
      ]]
    });

    this.formSub?.unsubscribe();
    this.formSub = this.userProfileForm1.valueChanges.subscribe(() => {
      if (this.isLoadingDetails) return;
      if (!this.isFormChanged) {
        this.userProfileForm1.markAsPristine();
      } else {
        this.userProfileForm1.markAsDirty();
      }
    });
  }

  async getUserDetail() {
    this.isLoadingDetails = true;
    this.userService.detail(this.userID).subscribe(async (response: any) => {
      if (response && response.data) {
        const data = this.userDetail = response.data;
        const cleanTelephone = (data.telephone || '').toString().replace(/[^0-9]/g, '');

        if (this.currentUserData) {
          if (data?.slug) this.currentUserData.slug = data.slug;
          if (data?.company) this.currentUserData.company = data.company;
          if (data?.firstName) this.currentUserData.firstName = data.firstName;
          if (data?.lastName) this.currentUserData.lastName = data.lastName;
          const userStr = JSON.stringify(this.currentUserData);
          this.storageService.setValue(StorageKey.currentUser, userStr);
          try {
            localStorage.setItem('currentUser', userStr);
          } catch { }
        }

        const data1 = {
          id: data.id,
          userType: data.userType,
          industryVertical: data.industryVertical,
          typeOfAgency: data.typeOfAgency,
          company: data.company,
          firstName: data.firstName,
          lastName: data.lastName,
          address: data.address,
          slug: data.slug,
          postalCode: data.postalCode,
          countryId: data.countryId,
          stateId: data.stateId,
          cityId: data.cityId,
          telephone: cleanTelephone,
          email: data.email,
          web_url: data.web_url,
        };

        this.userProfileForm1.patchValue(data1, { emitEvent: false });
        this.f1.id.setValue(data.id, { emitEvent: false });
        this.f1.countryId.setValue(data.countryId, { emitEvent: false });
        this.f1.telephone.setValue(cleanTelephone, { emitEvent: false });
        this.f1.stateId.setValue(data.stateId, { emitEvent: false });
        this.f1.cityId.setValue(data.cityId, { emitEvent: false });

        this.userProfileForm1.updateValueAndValidity();
        this.userProfileForm1.markAsPristine();
        this.userProfileForm1.markAsUntouched();
        this.submittedUserProfileForm1 = false;

        this.captureInitialFormValues();

        this.isOrganizationUser =
          data.userType.includes(UserTypeEnum.ORGANIZATION) ||
          data.userType.includes(UserTypeEnum.BASE_ORGANIZATION) ||
          data.userType.includes(UserTypeEnum.ORGANIZATION_CATALOG) ||
          data.userType.includes(UserTypeEnum.ORGANIZATION_LITE);

        if (data?.profile_photo) {
          this.previews = [data.profile_photo];
        }
        if (data?.company_logo) {
          this.previewsLogo = [data.company_logo];
        }
        if (data?.cover_photo) {
          this.previewsCover = [data.cover_photo];
        }

        if (data?.userType) {
          if (this.isOrganizationUser) {
            this.businessuserService.generate_qrcode().subscribe(async (responseQr: any) => {
              if (responseQr.success) {
                this.businessQRCode = responseQr.data.qrCodeURL;
                this.businessQRValue = responseQr.data.qrCodeValue;
                this.qrCodeValue = this.businessQRValue || '';
              }
            });
          } else if (data.userType.includes(UserTypeEnum.RETAILER)) {
            this.retailStoreService.generate_qrcode().subscribe(async (responseQr: any) => {
              if (responseQr.success) {
                this.businessQRCode = responseQr.data.qrCodeURL;
                this.businessQRValue = responseQr.data.qrCodeValue;
                this.qrCodeValue = this.businessQRValue || '';
              }
            });
          }
        }

        const country = this.countryList.find(x => x.id == data.countryId);
        this.countryCode = country ? country.code : '';

        if (data.countryId) {
          this.countryFilterList = this.countryList.filter(x => x.id == data.countryId);
        }

        if (data.countryId) {
          this.utilityService.getStatesList(data.countryId).subscribe((resState: any) => {
            if (resState.success) {
              this.stateList = resState.data;
              this.f1.stateId.setValue(data.stateId, { emitEvent: false });
            } else {
              this.stateList = [];
            }
            if (data.stateId) {
              this.stateFilterList = this.stateList.filter(x => x.id == data.stateId);
            }

            if (data.stateId) {
              this.utilityService.getCityList(data.stateId).subscribe((rescity: any) => {
                if (rescity.success) {
                  this.cityList = rescity.data;
                  this.f1.cityId.setValue(data.cityId, { emitEvent: false });
                } else {
                  this.cityList = [];
                }
                if (data.cityId) {
                  this.cityFilterList = this.cityList.filter(x => x.id == data.cityId);
                }
                this.captureInitialFormValues();
                this.userProfileForm1.markAsPristine();
                this.userProfileForm1.markAsUntouched();
                this.isLoadingDetails = false;
              });
            } else {
              this.captureInitialFormValues();
              this.userProfileForm1.markAsPristine();
              this.userProfileForm1.markAsUntouched();
              this.isLoadingDetails = false;
            }
          });
        } else {
          this.captureInitialFormValues();
          this.userProfileForm1.markAsPristine();
          this.userProfileForm1.markAsUntouched();
          this.isLoadingDetails = false;
        }
      } else {
        this.isLoadingDetails = false;
      }
    }, () => {
      this.isLoadingDetails = false;
    });
  }

  selectFiles(event: any): void {
    this.selectedFileNames = [];
    this.selectedFiles = event.target.files;
    this.previews = [];

    if (this.selectedFiles && this.selectedFiles[0]) {
      Array.from(this.selectedFiles).forEach((file: File) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previews.push(this.sanitizer.bypassSecurityTrustUrl(e.target.result));
        };
        reader.readAsDataURL(file);
      });
    }
  }

  selectLogoFiles(event: any): void {
    this.selectedLogoFiles = event.target.files;
    this.previewsLogo = [];

    if (this.selectedLogoFiles && this.selectedLogoFiles[0]) {
      Array.from(this.selectedLogoFiles).forEach((file: File) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previewsLogo.push(this.sanitizer.bypassSecurityTrustUrl(e.target.result));
        };
        reader.readAsDataURL(file);
      });
    }
  }

  onClickUploadProfile() {
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      const file = this.selectedFiles[0];
      const formData = new FormData();
      formData.append('file', file, file.name);

      this.userService.profile_photo(formData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.getUserDetail();
            this.valueChangeEditProfile.emit();
          }
        },
        error: () => this.alertService.showError('Photo upload failed')
      });
    } else {
      this.alertService.showError('Please select photo');
    }
  }

  async upload(): Promise<void> {
    const fileToUpload = this.compressedFile || this.originalFile;
    if (!fileToUpload) {
      this.alertService.showError('Please select cover photo');
      return;
    }

    const fd = new FormData();
    fd.append('file', fileToUpload, fileToUpload.name);

    this.uploading = true;
    this.userService.cover_photo(fd).subscribe({
      next: (response: any) => {
        this.uploading = false;
        if (response.success) {
          this.getUserDetail();
          this.valueChangeEditProfile.emit();
        } else {
          this.alertService.showError(response.message || 'Cover upload failed');
        }
      },
      error: () => {
        this.uploading = false;
        this.alertService.showError('Cover upload failed');
      }
    });
  }

  onClickUploadLogo() {
    if (this.selectedLogoFiles && this.selectedLogoFiles.length > 0) {
      var file = this.selectedLogoFiles[0];
      const formData = new FormData();
      formData.append('file', file, file.name);

      this.userService.company_logo(formData).subscribe((response: any) => {
        if (response.success) {
          this.getUserDetail();
          this.valueChangeEditProfile.emit();
        }
      });
    } else {
      this.alertService.showError('Please select logo');
    }
  }

  private async validateCover(file: File): Promise<boolean> {
    this.coverError = null;
    this.selectedCoverMeta = { name: file.name, bytes: file.size };

    const minBytes = this.minCoverKB * 1024;
    const maxBytes = this.maxCoverMB * 1024 * 1024;
    if (file.size < minBytes || file.size > maxBytes) {
      this.coverError = `File size must be between ${this.minCoverKB} KB and ${this.maxCoverMB} MB.`;
      return false;
    }
    
    // const { w, h } = await this.readImageDims(file);
    // this.selectedCoverMeta.w = w; this.selectedCoverMeta.h = h;

    // if (w < this.minW || h < this.minH) {
    //   this.coverError = `Minimum resolution is ${this.minW}×${this.minH}px.`;
    //   return false;
    // }

    // const ratio = +(w / h).toFixed(3);
    // this.selectedCoverMeta.ratio = ratio;
    // const minAspect = this.targetAspect * (1 - this.aspectTolerance);
    // const maxAspect = this.targetAspect * (1 + this.aspectTolerance);
    // if (ratio < minAspect || ratio > maxAspect) {
    //   this.coverError = `Aspect ratio must be ~${this.targetAspect}:1 (your image is ${ratio}:1).`;
    //   return false;
    // }
    return true;
  }

  onCoverFilesSelected(event: any): void {
    this.selectedCoverFiles = event.target.files;
    this.previewsCover = [];

    if (this.selectedCoverFiles && this.selectedCoverFiles[0]) {
      const file = this.selectedCoverFiles[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewsCover = [this.sanitizer.bypassSecurityTrustUrl(e.target.result)];
      };
      reader.readAsDataURL(file);
    }
  }

  async onClickUploadCover(): Promise<void> {
    const file = (this.compressedFile as File) ?? (this.originalFile as File) ?? this.selectedCoverFiles?.[0];
    if (!file) { this.alertService.showError('Please select cover photo'); return; }

    const formData = new FormData();
    formData.append('file', file, file.name);

    this.userService.cover_photo(formData).subscribe((response: any) => {
      if (response.success) {
        this.getUserDetail();
        this.valueChangeEditProfile.emit();
      }
    });
  }

  public prettyBytes(b: number | undefined): string {
    if (b === undefined) return '';
    const u = ['B', 'KB', 'MB', 'GB']; let i = 0, n = b;
    while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
    return `${n < 10 ? n.toFixed(2) : n.toFixed(1)} ${u[i]}`;
  }

  private readImageDims(file: File): Promise<{ w: number; h: number }> {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => { resolve({ w: img.naturalWidth, h: img.naturalHeight }); URL.revokeObjectURL(url); };
      img.onerror = e => { reject(e); URL.revokeObjectURL(url); };
      img.src = url;
    });
  }

  private getCoverValidationMessage(sizeB: number, w: number, h: number): string | null {
    const minBytes = this.minCoverKB * 1024;
    const maxBytes = this.maxCoverMB * 1024 * 1024;

    if (sizeB < minBytes || sizeB > maxBytes) {
      return `File size must be ≥ ${this.minCoverKB} KB and ≤ ${this.maxCoverMB} MB (selected ${this.prettyBytes(sizeB)}).`;
    }
    if (w < this.minW || h < this.minH) {
      return `Minimum resolution is ${this.minW}×${this.minH}px (selected ${w}×${h}).`;
    }
    const ratio = w / h;
    const minA = this.targetAspect * (1 - this.aspectTolerance);
    const maxA = this.targetAspect * (1 + this.aspectTolerance);
    if (ratio < minA || ratio > maxA) {
      return `Aspect ratio must be ~${this.targetAspect}:1 (selected ${ratio.toFixed(2)}:1).`;
    }
    return null;
  }

  private humanFileSize(bytes: number): string {
    const thresh = 1024;
    if (bytes < thresh) return `${bytes} B`;
    const units = ['KB', 'MB', 'GB', 'TB'];
    let u = -1;
    do { bytes /= thresh; ++u; }
    while (bytes >= thresh && u < units.length - 1);
    const dp = bytes >= 10 || u === 0 ? 1 : 2;
    return `${bytes.toFixed(dp)} ${units[u]}`;
  }

  noOnlySpaces(control: any) {
    if (!control.value) return null;
    return control.value.trim().length === 0 ? { onlySpaces: true } : null;
  }

  onlyNumbers(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  }

  public getStateList(countryId: any) {
    this.utilityService.getStatesList(countryId).subscribe((res: any) => {
      if (res.success) {
        this.stateList = res.data;
      } else {
        this.stateList = [];
      }
      this.stateFilterList = this.stateList;
    });
  }

  public getCityList(stateId: any) {
    this.utilityService.getCityList(stateId).subscribe((res: any) => {
      if (res.success) {
        this.cityList = res.data;
      } else {
        this.cityList = [];
      }
      this.cityFilterList = this.cityList;
    });
  }

  onChangeCountry(event: any) {
    if (this.isLoadingDetails) return;
    this.countryFilterList = this.countryList?.filter(x => (x.name.toLowerCase()).includes(event?.toLowerCase?.() || ''));
    if (event) {
      const country = this.countryList.find(x => x.id == event);
      if (country) {
        this.countryCode = country.code;
        this.stateList = [];
        this.cityList = [];
        this.f1.stateId.setValue('');
        this.f1.cityId.setValue('');
        this.getStateList(event);
      } else {
        this.countryCode = '';
        this.stateList = [];
        this.cityList = [];
        this.f1.stateId.setValue('');
        this.f1.cityId.setValue('');
      }
    } else {
      this.countryCode = '';
      this.f1.stateId.setValue('');
      this.f1.cityId.setValue('');
      this.stateList = [];
      this.cityList = [];
    }
      // if (event.value) {
    //   let country = this.countryList.find(x => x.id == event.value)
    //   if (country) {
    //     this.countryCode = country.code;
    //     // this.f1.countryCode.setValue(country.code);
    //     this.stateList = [];
    //     this.cityList = [];
    //     this.f1.stateId.setValue('');
    //     this.f1.cityId.setValue('');
    //   }
    //   else {
    //     this.countryCode = "";
    //     // this.f1.countryCode.setValue('');
    //     this.stateList = [];
    //     this.cityList = [];
    //     this.f1.stateId.setValue('');
    //     this.f1.cityId.setValue('');
    //   }
    //   this.getStateList(event.value);
    // }
    // else {
    //   this.countryCode = "";
    //   // this.f1.countryCode.setValue('');
    //   this.f1.stateId.setValue('');
    //   this.f1.cityId.setValue('');
    //   this.stateList = [];
    //   this.cityList = [];
    // }
  }

  displayFnCountry = (id: string): string => {
    const country = this.countryList?.find(el => el.id == id) ?? {};
    return country.name;
  }

  onChangeState(event: any) {
    if (this.isLoadingDetails) return;
    this.stateFilterList = this.stateList?.filter(x => (x.name.toLowerCase()).includes(event?.toLowerCase?.() || ''));
    this.f1.cityId.setValue('');
    if (event) {
      const state = this.stateList.find(x => x.id == event);
      if (state) {
        this.getCityList(event);
      } else {
        this.cityList = [];
      }
    } else {
      this.cityList = [];
    }
        // if (event.value) {
    //   this.getCityList(event.value);
    // } else {
    //   this.cityList = [];
    // }
  }

  displayFnState = (id: string): string => {
    const state = this.stateList?.find(el => el.id == id) ?? {};
    return state.name;
  }

  onChangeCity(event: any) {
    if (this.isLoadingDetails) return;
    this.cityFilterList = this.cityList?.filter(x => (x.name.toLowerCase()).includes(event?.toLowerCase?.() || ''));
  }

  displayFnCity = (id: string): string => {
    const city = this.cityList?.find(el => el.id == id) ?? {};
    return city.name;
  }

  onClickUserProfileForm1() {
    this.submittedUserProfileForm1 = true;
    if (this.userProfileForm1.invalid || !this.isFormChanged || this.isSubmitting) {
      return;
    }
        const formData = this.userProfileForm1.getRawValue();

    //  const userId = this.currentUserData?.id; // update as per actual key
    // const formData = this.userProfileForm1.value;
    //    this.userService.profile_update(userId, formData).subscribe({

    //   next: (res) => {
    //     //console.log('Profile updated:', res);
    //     // Show success message
    //   },
    //   error: (err) => {
    //     console.error('Error updating profile:', err);
    //     if (err.error?.details) {
    //       console.error('Validation details:', err.error.details);
    //     }
    //   },
    // });


    let isValidForm = true;
    if (this.f1.countryId.value) {
      const country = this.countryList.find(x => x.id == this.f1.countryId.value);
      if (!country) {
        isValidForm = false;
        this.countryCode = '';
        this.f1.countryId.setValue('');
      }
    }

    if (this.f1.stateId.value) {
      const state = this.stateList.find(x => x.id == this.f1.stateId.value);
      if (!state) {
        isValidForm = false;
        this.f1.stateId.setValue('');
      }
    }

    if (this.f1.cityId.value) {
      const city = this.cityList.find(x => x.id == this.f1.cityId.value);
      if (!city) {
        isValidForm = false;
        this.f1.cityId.setValue('');
      }
    }

    if (isValidForm) {
      const model: any = {
        id: this.f1.id.value || this.userID,
        web_url: this.f1.web_url.value,
        firstName: this.f1.firstName.value,
        lastName: this.f1.lastName.value,
        company: this.f1.company.value,
        address: this.f1.address.value,
        slug: this.f1.slug.value,
        countryId: this.f1.countryId.value,
        stateId: this.f1.stateId.value,
        cityId: this.f1.cityId.value,
        email: this.f1.email.value,
        telephone: this.f1.telephone.value
      };

      this.update(model);
    }
  }

  update(model: any) {
    this.isSubmitting = true;
    this.userService.profile_update(model.id, model).pipe(first()).subscribe({
      next: (response: any) => {
        this.isSubmitting = false;
        if (response.success) {
          if (this.currentUserData) {
            const updatedSlug = response.data?.slug || model.slug;
            if (updatedSlug) this.currentUserData.slug = updatedSlug;
            if (model.company) this.currentUserData.company = model.company;
            if (model.firstName) this.currentUserData.firstName = model.firstName;
            if (model.lastName) this.currentUserData.lastName = model.lastName;
            const userStr = JSON.stringify(this.currentUserData);
            this.storageService.setValue(StorageKey.currentUser, userStr);
            try {
              localStorage.setItem('currentUser', userStr);
            } catch { }
          }

          this.captureInitialFormValues();
          this.userProfileForm1.markAsPristine();
          this.userProfileForm1.markAsUntouched();
          this.submittedUserProfileForm1 = false;
          this.getUserDetail();
          this.valueChangeEditProfile.emit();
        } else {
          this.alertService.showError(response.message || 'Failed to update profile');
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        this.alertService.showError(err?.error?.message || 'Error updating profile');
      }
    });
  }


 
  // private cropToAspect(
  //   img: HTMLImageElement,
  //   aspect = 8 / 1
  // ): { sx: number; sy: number; sw: number; sh: number } {
  //   const { naturalWidth: w, naturalHeight: h } = img;
  //   const srcAspect = w / h;

  //   if (srcAspect > aspect) {
  //     const sw = Math.floor(h * aspect);
  //     const sx = Math.floor((w - sw) / 2);
  //     return { sx, sy: 0, sw, sh: h };
  //   } else {
  //     const sh = Math.floor(w / aspect);
  //     const sy = Math.floor((h - sh) / 2);
  //     return { sx: 0, sy, sw: w, sh };
  //   }
  // }

  // private revokePreview() {
  //   if (this.previewObjectUrl) {
  //     URL.revokeObjectURL(this.previewObjectUrl);
  //     this.previewObjectUrl = null;
  //   }
  //   this.previewUrl = null;
  // }

  // private readImage(file: File): Promise<HTMLImageElement> {
  //   return new Promise((res, rej) => {
  //     const url = URL.createObjectURL(file);
  //     const img = new Image();
  //     img.decoding = 'async';
  //     img.onload = () => { URL.revokeObjectURL(url); res(img); };
  //     img.onerror = (e) => { URL.revokeObjectURL(url); rej(e); };
  //     img.src = url;
  //   });
  // }


  /*
  // COMPRESSION CODE COMMENTED OUT TEMPORARILY
  private cropTo8x1(img: HTMLImageElement) {
    const w = img.naturalWidth, h = img.naturalHeight, aspect = 8;
    const srcAspect = w / h;

    if (srcAspect > aspect) {
      const sw = Math.floor(h * aspect);
      const sx = Math.floor((w - sw) / 2);
      return { sx, sy: 0, sw, sh: h };
    } else {
      const sh = Math.floor(w / aspect);
      const sy = Math.floor((h - sh) / 2);
      return { sx: 0, sy, sw: w, sh };
    }
  }

  private readonly FRAME_W = 3200;
  private readonly FRAME_H = 400;

  private async makeCoverFile(img: HTMLImageElement, preferPng = false): Promise<File> {
    const FRAME_W = this.FRAME_W;
    const FRAME_H = this.FRAME_H;

    const { sx, sy, sw, sh } = this.cropTo8x1(img);

    const canvas = document.createElement('canvas');
    canvas.width = FRAME_W;
    canvas.height = FRAME_H;
    const ctx = canvas.getContext('2d')!;

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, sx, sy, sw, sh, 0, 0, FRAME_W, FRAME_H);

    const mime = preferPng ? 'image/png' : 'image/jpeg';
    const maxBytes = this.maxCoverMB * 1024 * 1024;
    let q = 0.9;
    let blob: Blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), mime, q));

    if (blob.size > maxBytes && mime === 'image/png') {
      let jq = 0.9;
      blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), 'image/jpeg', jq));
      while (blob.size > maxBytes && jq > 0.4) {
        jq -= 0.1;
        blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), 'image/jpeg', jq));
      }
      return new File([blob], 'cover.jpg', { type: 'image/jpeg' });
    }

    while (blob.size > maxBytes && q > 0.4 && mime === 'image/jpeg') {
      q -= 0.1;
      blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), mime, q));
    }
    return new File([blob], `cover.${mime === 'image/png' ? 'png' : 'jpg'}`, { type: mime });
  }

  private async makeLogoFile(img: HTMLImageElement, preferPng = true): Promise<File> {
    const SIZE = 512;
    const canvas = document.createElement('canvas');
    canvas.width = SIZE;
    canvas.height = SIZE;

    const ctx = canvas.getContext('2d')!;
    ctx.fillStyle = preferPng ? 'rgba(0,0,0,0)' : '#FFFFFF';
    ctx.fillRect(0, 0, SIZE, SIZE);

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    const s = Math.min(SIZE / img.naturalWidth, SIZE / img.naturalHeight);
    const drawW = Math.round(img.naturalWidth * s);
    const drawH = Math.round(img.naturalHeight * s);
    const dx = Math.floor((SIZE - drawW) / 2);
    const dy = Math.floor((SIZE - drawH) / 2);

    ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, dx, dy, drawW, drawH);

    const mime = preferPng ? 'image/png' : 'image/jpeg';
    const maxBytes = 1 * 1024 * 1024;
    let q = 0.9;
    let blob: Blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), mime, q));
    while (blob.size > maxBytes && q > 0.4 && mime === 'image/jpeg') {
      q -= 0.1;
      blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), mime, q));
    }

    return new File([blob], `logo.${mime === 'image/png' ? 'png' : 'jpg'}`, { type: mime });
  }
  */ 

  private async toBlobSafe(canvas: HTMLCanvasElement, mime: string, quality?: number): Promise<Blob> {
    const b: Blob | null = await new Promise(resolve => canvas.toBlob(resolve, mime, quality));
    if (b) return b;
    const dataUrl = canvas.toDataURL(mime, quality);
    const res = await fetch(dataUrl);
    return await res.blob();
  }

  private readImage(file: File): Promise<HTMLImageElement> {
    return new Promise((res, rej) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => { URL.revokeObjectURL(url); res(img); };
      img.onerror = (e) => { URL.revokeObjectURL(url); rej(e); };
      img.src = url;
    });
  }

  private revokePreview() {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
      this.previewObjectUrl = null;
    }
    this.previewUrl = null;
  }

  async onFileSelected(ev: Event): Promise<void> {
    const input = ev.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const isPng = /image\/png/i.test(file.type);
    const isJpg = /image\/jpe?g/i.test(file.type);
    if (!isPng && !isJpg) {
      this.alertService.showError('Please select a JPG or PNG.');
      input.value = '';
      return;
    }

    const minBytes = 49 * 1024;
    const maxBytes = this.maxCoverMB * 1024 * 1024;
    if (file.size < minBytes || file.size > maxBytes) {
      this.alertService.showError(
        `File size must be between ${this.prettyBytes(minBytes)} and ${this.maxCoverMB} MB.`
      );
      input.value = '';
      return;
    }

    let img: HTMLImageElement;
    try { img = await this.readImage(file); }
    catch { this.alertService.showError('Could not read the image.'); input.value = ''; return; }

    if (img.naturalWidth < this.minW || img.naturalHeight < this.minH) {
      this.coverError = `Source image (${img.naturalWidth}×${img.naturalHeight}px) is below the recommended minimum of ${this.minW}×${this.minH}px. Image quality may be affected.`;
    } else {
      this.coverError = null;
    }

    const coverFile = file;

    this.revokePreview();
    const objUrl = URL.createObjectURL(coverFile);
    this.previewObjectUrl = objUrl;
    this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(objUrl);

    this.originalFile = file;
    this.compressedFile = coverFile;
    this.originalSize = this.prettyBytes(file.size);
    this.compressedSize = this.prettyBytes(coverFile.size);
  }

  // private async makeCoverFileStretch(
//   img: HTMLImageElement,
//   preferPng = false
// ): Promise<File> {
//   const FRAME_W = 3200;
//   const FRAME_H = 400;

//   const canvas = document.createElement('canvas');
//   canvas.width = FRAME_W;
//   canvas.height = FRAME_H;

//   const ctx = canvas.getContext('2d')!;
//   ctx.fillStyle = preferPng ? 'rgba(0,0,0,0)' : '#FFFFFF';
//   ctx.fillRect(0, 0, FRAME_W, FRAME_H);

//   ctx.imageSmoothingEnabled = true;
//   ctx.imageSmoothingQuality = 'high';

//   ctx.drawImage(
//     img,
//     0, 0, img.naturalWidth, img.naturalHeight,
//     0, 0, FRAME_W, FRAME_H
//   );

//   const mime = preferPng ? 'image/png' : 'image/jpeg';
//   const maxBytes = this.maxCoverMB * 1024 * 1024;
//   let q = 0.9;
//   let blob: Blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), mime, q));
//   while (blob.size > maxBytes && q > 0.4 && mime === 'image/jpeg') {
//     q -= 0.1;
//     blob = await new Promise(r => canvas.toBlob(b => r(b as Blob), mime, q));
//   }

//   return new File([blob], `cover.${mime === 'image/png' ? 'png' : 'jpg'}`, { type: mime });
// }

  async onLogoFileSelected(ev: Event): Promise<void> {
    const input = ev.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const isPng = /image\/png/i.test(file.type);
    const isJpg = /image\/jpe?g/i.test(file.type);
    if (!isPng && !isJpg) {
      this.alertService.showError('Please select a JPG or PNG.');
      input.value = '';
      return;
    }

    const minBytes = 49 * 1024;
    const maxBytes = this.maxLogoMB * 1024 * 1024;
    if (file.size < minBytes || file.size > maxBytes) {
      this.alertService.showError(
        `File size must be between ${this.prettyBytes(minBytes)} and ${this.maxLogoMB} MB.`
      );
      input.value = '';
      return;
    }

    let img: HTMLImageElement;
    try { img = await this.readImage(file); }
    catch { this.alertService.showError('Could not read the image.'); input.value = ''; return; }

    // Direct file reference without compression
    // const out = await this.makeLogoFile(img, true);
    const out = file;

    this.revokeLogoPreview();
    const objUrl = URL.createObjectURL(out);
    this.logoPreviewObjectUrl = objUrl;
    this.logoPreviewUrl = this.sanitizer.bypassSecurityTrustUrl(objUrl);

    this.logoOriginalFile = file;
    this.logoCompressedFile = out;
    this.logoOriginalSize = this.prettyBytes(file.size);
    this.logoCompressedSize = this.prettyBytes(out.size);
  }

  async uploadLogo(): Promise<void> {
    const fileToUpload = this.logoCompressedFile || this.logoOriginalFile;
    if (!fileToUpload) {
      this.alertService.showError('Please select logo');
      return;
    }

    const fd = new FormData();
    fd.append('file', fileToUpload, fileToUpload.name);

    this.uploading = true;
    this.userService.company_logo(fd).subscribe({
      next: (res: any) => {
        this.uploading = false;
        if (res.success) {
          this.getUserDetail();
          this.valueChangeEditProfile.emit();
        }
      },
      error: () => {
        this.uploading = false;
        this.alertService.showError('Logo upload failed');
      }
    });
  }

  private revokeLogoPreview() {
    if (this.logoPreviewObjectUrl) {
      URL.revokeObjectURL(this.logoPreviewObjectUrl);
      this.logoPreviewObjectUrl = null;
    }
    this.logoPreviewUrl = null;
  }

  ngOnDestroy(): void {
    this.formSub?.unsubscribe();
    this.revokePreview();
    this.revokeLogoPreview();
  }
}
